import React from "react";

import PaymentOutcome from "../../components/payment-outcome/payment-outcome";

const PaymentResult = () => (
  <div className="signup-container">
    <div className="signup-card">
      <PaymentOutcome />
    </div>
  </div>
);

export default PaymentResult;
